import { BASE_API_URL } from '@/lib/constants';
import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

type Request = {
  coids: string;
  program: string;
  NPIs: string;
};

type Response = {
  data: string;
};

const URL = `${BASE_API_URL}/generate-profile-url`;

const generateProfileUrl = async (payload: Request): Promise<Response> => {
  const response = await fetch(URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  return response.json();
};

const useGenerateProfileUrl = (
  options: UseMutationOptions<Response, Error, Request, unknown>
): UseMutationResult<Response, Error, Request, unknown> =>
  useMutation({
    mutationFn: generateProfileUrl,
    ...options,
  });

export default useGenerateProfileUrl;
